var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.show ? _c('div', {
    staticClass: "popHowWorks",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "shadow",
    on: {
      "click": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "popHowWorks-main",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    }
  }, [_c('button', {
    staticClass: "popHowWorks-close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("×")]), _vm._m(0), _vm._m(1), _c('div', {
    staticClass: "howWorks-actions"
  }, [_c('button', {
    staticClass: "howWorks-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Explore tokens")]), _c('button', {
    staticClass: "howWorks-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSkip
    }
  }, [_vm._v("Launch a token "), _c('span', [_vm._v("→")])])])])])]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "howWorks-hero"
  }, [_c('div', {
    staticClass: "howWorks-brand"
  }, [_c('img', {
    attrs: {
      "src": require("@images/ui/wave-logo.svg"),
      "alt": "Wave"
    }
  })]), _c('div', {
    staticClass: "howWorks-copy"
  }, [_c('div', {
    staticClass: "howWorks-kicker"
  }, [_c('i'), _vm._v("HOW WAVE WORKS")]), _c('h2', [_vm._v("From an idea"), _c('br'), _vm._v("to an open market.")]), _c('p', [_vm._v("Every token starts fairly on a transparent bonding curve, then graduates to onchain liquidity on Robinhood Chain.")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "howWorks-body"
  }, [_c('div', {
    staticClass: "howWorks-track"
  }, [_c('article', [_c('b', [_vm._v("01")]), _c('div', [_c('h3', [_vm._v("Launch")]), _c('p', [_vm._v("Choose a name, symbol and artwork. No presale or private allocation.")])])]), _c('article', [_c('b', [_vm._v("02")]), _c('div', [_c('h3', [_vm._v("Ride the curve")]), _c('p', [_vm._v("The price moves with demand while every buy and sell remains visible onchain.")])])]), _c('article', [_c('b', [_vm._v("03")]), _c('div', [_c('h3', [_vm._v("Graduate")]), _c('p', [_vm._v("At the target, liquidity moves to Uniswap V3 and trading continues on the open market.")])])])]), _c('aside', {
    staticClass: "howWorks-note"
  }, [_c('span', [_vm._v("THE WAVE PRINCIPLE")]), _c('strong', [_vm._v("Same entry."), _c('br'), _vm._v("Same curve."), _c('br'), _vm._v("Open liquidity.")]), _c('p', [_vm._v("Built for communities, not insiders.")])])]);
}];
export { render, staticRenderFns };